import script from "./MessagePrintPopupView.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagePrintPopupView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__